import dayjs from 'dayjs'

export function formatDatetimeToLocalTime(datetime: string): string {
  return dayjs(datetime).format('LT')
}
